<div>
  <app-loading>
    <ng-container body>
      <div class="redirect-text">Pending verification from DocuSign</div>
      <div class="redirect-subtext">This may take up to 60 seconds</div>
    </ng-container>
  </app-loading>
</div>
